import React from 'react';

import classes from './styles.module.css';

const Loader = ({ isString, color }) => {
    const styles = {
        position: null,
        loader: null,
        color: null,
    };

    switch (isString) {
        case true:
            styles.position = classes.ButtonPosition;
            styles.loader = classes.ButtonLoader;
            break;
        default:
            styles.position = classes.Position;
            styles.loader = classes.Loader;
    }

    switch (color) {
        case 'grey':
            styles.color = classes.Grey;
            break;
        default:
            styles.color = classes.White;
    }

    return (
        <div className={styles.position}>
            <div className={`${styles.color} ${styles.loader}`} />
        </div>
    );
};

export default Loader;



// WEBPACK FOOTER //
// ./src/Components/Utils/Loader/index.js